import React from 'react';
import { ILabelValuePanel } from '../../../../../../../../theme/ui/Dashboard/Dashboard.model';
import { CommanderOfflinePanelProps } from './CommanderOfflinePanel';
import { CBoxOfflineIcon } from '../../../../../../../../assets/dashboard';
import { useTranslation } from 'react-i18next';
import { CommanderAPI } from '../../../../../../../../service/device/CommanderAPI/CommanderAPI';
import { DefaultRightContainer } from '../../../../../../../../theme/ui/Dashboard/LabelValuePanel/LabelValuePanel';
import { skipToken } from '@reduxjs/toolkit/query';
import LabelValuePanel from '../../../../../../../../theme/ui/Dashboard/LabelValuePanel/LabelValuePanel';

function CommanderOfflineGroupPanel(props: CommanderOfflinePanelProps) {
  const { panel, layout } = props;
  const { groupId } = panel;
  const {
    isFetching,
    currentData,
    error: errorDevicesConnectionStatus,
  } = CommanderAPI.useGetDevicesConnectionStatusCountByGroupQuery(
    groupId ?? skipToken
  );
  const { t } = useTranslation();

  const labelValuePanel: ILabelValuePanel = {
    type: 'LABEL_VALUE',
    id: `groupId:${groupId}`,
    title: panel.title,
    icon: <CBoxOfflineIcon height={'100%'} />,
    content: (
      <DefaultRightContainer>
        {currentData?.mqttDisconnected}
      </DefaultRightContainer>
    ),
    loading: isFetching,
    error: errorDevicesConnectionStatus
      ? t('dashboard.error.fetching')
      : undefined,
  };
  return <LabelValuePanel panel={labelValuePanel} layout={layout} />;
}

export default CommanderOfflineGroupPanel;
